// extracted by mini-css-extract-plugin
export var block = "style-module--block--82cc5";
export var detailes = "style-module--detailes--c30a0";
export var pseudo = "style-module--pseudo--d9d8e";
export var pseudoTriangle = "style-module--pseudo-triangle--9ce1b";
export var text = "style-module--text--adc98";